/* Keep the tab icon in step with the applied storefront mode, including transitions. */
(function () {
  'use strict';
  var root = document.documentElement;
  function sync() {
    var variant = root.getAttribute('data-piex-mode') === 'halloween' ? 'data-dark' : 'data-light';
    document.querySelectorAll('[data-piex-favicon]').forEach(function (icon) {
      var href = icon.getAttribute(variant);
      if (href && icon.getAttribute('href') !== href) icon.setAttribute('href', href);
    });
  }
  sync();
  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['data-piex-mode'] });
}());
